<template>
  <v-card class="mb-2">
    <v-card-title class="font-weight-bold">门店数量</v-card-title>
    <v-card-text>
      <v-chart autoresize :option="option" style="height: 300px" />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ["xAxisData", "data"],
  computed: {
    option() {
      return {
        color: ["#87B957"],
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },

        legend: {
          data: ["门店数量"],
        },
        xAxis: [
          {
            type: "category",
            data: this.xAxisData,
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              rotate: 90,
              width: 60,
              height: 30,
              overflow: "truncate",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "门店数量",
            type: "bar",
            stack: "Ad",
            emphasis: {
              focus: "series",
            },
            data: this.data,
            label: {
              show: true,
              position: "top",
            },
          },
        ],
        dataZoom: [
        {
            id: 'dataZoomX',
            type: 'slider',
            xAxisIndex: [0],
            filterMode: 'none',
            start: 0,
            end: ((7/this.xAxisData.length)*100),
            minSpan:((7/this.xAxisData.length)*100),
            maxSpan:((7/this.xAxisData.length)*100),
            brushSelect:false
        }
    ],
      };
    },
  },
  data: () => ({}),
};
</script>

<style lang="scss" scoped></style>
